export function useLogOut() {
	const logOut = async () => {
		await navigateTo("/api/auth/logout", { external: true })
	}
	return { logOut }
}
